import { useState } from 'react';
import WavesLogo from '../../../ui/svg/common/waves-logo';
import Preloader from '../../../ui/svg/common/preloader';
import { logout } from '../dal/data-provider';

interface ILogoutScreen {
    text? : string  ,
}

/**
 * logout screen
 * used in login, create account, and other membership pages
 * when the user is already logged in
 */
const LogoutScreen = (props: ILogoutScreen) => {

    const [isLoading, setIsLoading] = useState(false);

    /**
     * perform logout
     */
    const performLogout = async () => {

        setIsLoading(true);

        try{
            await logout();
        }
        catch (ex){
            console.log('Logout error:', ex);
        }

        window.location.reload();
    };

    return (
        <div className="mx-4">
            <div
                className="mx-auto mt-8"
                style={{
                    width: '400px',
                    maxWidth: '100%'
                }}>
                <div className="border rounded py-8 px-10 text-center">

                    <div className="flex justify-center mb-8">
                        <WavesLogo width="50px" height="51" color="#231f20" />
                    </div>

                    <div className="mb-6">
                        { props.text ? props.text : "You're already logged in. If you need to log in with a different account, please sign out first." }
                    </div>

                    {
                        isLoading &&
                        <div className="flex justify-center">
                            <Preloader width="25px" height="25px" color="#4f4f4f" />
                        </div>
                    }

                    {
                        !isLoading &&
                        <button
                            className="text-base bg-blue-200 text-white text-center rounded-3xl w-full py-2"
                            type="button"
                            onClick={async evt => {
                                await performLogout();
                            }}
                        >Sign Out</button>
                    }
                </div>
            </div>
        </div>
    )
};

export default LogoutScreen;